import { MaskLines, Reveal } from "@/components/Motion";
import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";
import evergemRender from "@/assets/images/3D_render_doornzele.webp";

const Hero = ({ onPrimaryProject, onSecondaryProject }) => {
  return (
    <section id="top" className="relative min-h-[100svh] w-full overflow-hidden bg-charcoal">
      <motion.img
        src={evergemRender}
        alt="Moderne nieuwbouwwoning van LX Bouw met strakke architectuur en warme materialen"
        className="absolute inset-0 h-full w-full object-cover"
        initial={{ scale: 1.15 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.8, ease: [0.22, 1, 0.36, 1] }}
        loading="eager"
        fetchPriority="high"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-charcoal/70 via-charcoal/20 to-charcoal/30" />

      <div className="relative z-10 mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 min-h-[100svh] flex flex-col justify-end pb-16 md:pb-24">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 1 }}
          className="font-body text-cream/80 text-sm tracking-[0.25em] uppercase mb-6"
        >
          Kwalitatieve woningbouw
        </motion.p>

        <h1 className="font-heading text-cream font-light tracking-tight text-4xl sm:text-6xl lg:text-[5.5rem] xl:text-[4.875rem] min-[1600px]:text-[5.5rem] leading-[1.02] max-w-5xl">
          <MaskLines
            testId="hero-headline"
            delay={0.35}
            lines={["Woningen gebouwd", "met zorg, vakmanschap", "en oog voor detail."]}
          />
        </h1>

        <Reveal delay={1.1} className="mt-8 max-w-xl">
          <p className="font-body text-cream/85 text-base md:text-lg leading-relaxed">
            LX Bouw realiseert kwalitatieve nieuwbouwwoningen en kleinschalige
            woonprojecten. Tijdloze architectuur, duurzame technieken en een
            persoonlijke aanpak van eerste schets tot oplevering.
          </p>
        </Reveal>

        <Reveal delay={1.3} className="mt-10 flex flex-col sm:flex-row gap-4">
          <button
            data-testid="hero-contact-btn"
            onClick={onPrimaryProject}
            className="group inline-flex items-center justify-center gap-3 rounded-cta bg-white text-ink px-8 py-4 text-sm font-medium tracking-wide transition-all duration-300 hover:bg-offwhite hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-ink"
          >
            Project in de kijker
          </button>
          <button
            data-testid="hero-realisaties-btn"
            onClick={onSecondaryProject}
            className="group inline-flex items-center justify-center gap-3 rounded-cta border border-white/40 bg-transparent text-white px-8 py-4 text-sm font-medium tracking-wide transition-all duration-300 hover:bg-white/10 hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-ink"
          >
            Bekijk onze realisaties
          </button>
        </Reveal>
      </div>

      <motion.div
        className="absolute bottom-8 right-6 md:right-10 z-10 text-cream/70"
        animate={{ y: [0, 10, 0] }}
        transition={{ duration: 2.2, repeat: Infinity, ease: "easeInOut" }}
      >
        <ArrowDown size={22} />
      </motion.div>
    </section>
  );
};

export default Hero;
